import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@lmc-env/environment';
import { AppsConversionData } from '@lmc-app/shared/interface/apps-conversion-data';

@Injectable({
	providedIn: 'root',
})
export class DashboardService {
	private readonly uri: string = environment.DO_URL;

	constructor(private readonly http: HttpClient) {}

	/**
	 * Get Apps Conversion data for a date range
	 * @param startDate - Start date in YYYY-MM-DD format
	 * @param endDate - End date in YYYY-MM-DD format
	 */
	getAppsConversion(startDate: string, endDate: string): Observable<AppsConversionData[]> {
		return this.http
			.get<{ success: boolean; data: AppsConversionData[] }>(
				this.uri + '/v2/dashboard/apps-conversion',
				{ params: { startDate, endDate } }
			)
			.pipe(map((res) => res.data));
	}
}
